var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6418_2740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6418_2740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21664 11.4166C8.60553 11.0278 8.79998 10.5555 8.79998 9.99998V5.59998H10.4V4.39998H7.59998V8.16664C7.47553 8.11109 7.34664 8.06942 7.21331 8.04164C7.07998 8.01386 6.9422 7.99998 6.79998 7.99998C6.24442 7.99998 5.7722 8.19442 5.38331 8.58331C4.99442 8.9722 4.79998 9.44442 4.79998 9.99998C4.79998 10.5555 4.99442 11.0278 5.38331 11.4166C5.7722 11.8055 6.24442 12 6.79998 12C7.35553 12 7.82775 11.8055 8.21664 11.4166ZM8.00464 14.4C7.12375 14.4 6.29442 14.2333 5.51664 13.9C4.73886 13.5666 4.05831 13.1083 3.47498 12.525C2.89164 11.9416 2.43331 11.2613 2.09998 10.484C1.76664 9.70664 1.59998 8.87609 1.59998 7.99231C1.59998 7.10853 1.76664 6.28053 2.09998 5.50831C2.43331 4.73609 2.89164 4.05831 3.47498 3.47498C4.05831 2.89164 4.73864 2.43331 5.51598 2.09998C6.29331 1.76664 7.12386 1.59998 8.00764 1.59998C8.89142 1.59998 9.71942 1.76664 10.4916 2.09998C11.2639 2.43331 11.9416 2.89164 12.525 3.47498C13.1083 4.05831 13.5666 4.73731 13.9 5.51198C14.2333 6.28675 14.4 7.11453 14.4 7.99531C14.4 8.8762 14.2333 9.70553 13.9 10.4833C13.5666 11.2611 13.1083 11.9416 12.525 12.525C11.9416 13.1083 11.2626 13.5666 10.488 13.9C9.7132 14.2333 8.88542 14.4 8.00464 14.4Z",
    fill: "#B3531B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenre);
export default __webpack_public_path__ + "static/media/genre.5d94c53ad3ce7ccdb43770f35bab24e2.svg";
export { ForwardRef as ReactComponent };